<template>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-12 col-xl-8">
          <!-- Card container -->
          <div class="card shadow-sm mb-4">
            <div class="card-header bg-primary text-white text-center">
              <h2 class="mb-0">Selecciona el mes y año del fichero</h2>
            </div>
            <div class="card-body">
              <!-- Selección de mes -->
              <div class="mb-3">
                <label for="month" class="form-label">Selecciona Mes</label>
                <select id="month" name="month" v-model="monthValue" class="form-select">
                  <option disabled value="">Selecciona un mes</option>
                  <option v-for="month in monthOptions" :key="month.id" :value="month">
                    {{ month.nombre }}
                  </option>
                </select>
                
              </div>
  
              <!-- Selección de año -->
              <div class="mb-3">
                <label for="year" class="form-label">Selecciona Año</label>
                <select id="year" name="year" v-model="anyoValue" class="form-select">
                  <option disabled value="">Selecciona un año</option>
                  <option v-for="year in anyoOptions" :key="year.id" :value="year">
                    {{ year.nombre }}
                  </option>
                </select>
              </div>
  
              <br>
              <p v-if="isSuccess" class="text-success"><button type="button" class="btn btn-primary"  @click="confirmarCargaDatos">Confirma carga de estos datos</button></p>

              <!-- Carga de archivos -->
              <div v-show="fechaIntroducida()" class="dropbox mt-4 p-4 rounded border">
                <input type="file" accept=".xls" :name="uploadFieldName" :disabled="isSaving"
                  @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
                  class="input-file form-control" />
                <div class="text-center">
                  <p v-if="isInitial" class="text-muted">Arrastra tu archivo aquí o haz clic para buscar</p>
                  <p v-if="isSaving" class="text-info">Cargando {{ fileCount }} archivo(s)...</p>
                  <p v-if="isSuccess" class="text-success">Archivo analizado. El formato parece correcto: {{ mensajeConfirmacion }}</p>
                  <p v-if="isSuccess" class="text-success">Mes de los datos: {{ datosCargados.month }}</p>
                  <p v-if="isSuccess" class="text-success">Año de los datos: {{ datosCargados.year }}</p>
                </div>
              </div>
              <br>
              <p v-if="isSaved" class="text-success">Archivo subido correctamente.</p>
              <p v-if="isSaved" class="text-success">{{ mensajeConfirmacion }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  
    import Multiselect from 'vue-multiselect'
    import {contabilidadService, putExcelContaplus} from '../_services';
    import 'bootstrap/dist/js/bootstrap.bundle.js';
  
    const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3, STATUS_SAVED = 4;
  
    export default {
      components: {
        Multiselect
      },
      data() {
        return {
          anyoValue: '',
          monthValue: '',
          anyoOptions: [],
          monthOptions: [
            {id: "01", nombre: "Enero"},
            {id: "02", nombre: "Febrero"},
            {id: "03", nombre: "Marzo"},
            {id: "04", nombre: "Abril"},
            {id: "05", nombre: "Mayo"},
            {id: "06", nombre: "Junio"},
            {id: "07", nombre: "Julio"},
            {id: "08", nombre: "Agosto"},
            {id: "09", nombre: "Septiembre"},
            {id: "10", nombre: "Octubre"},
            {id: "11", nombre: "Noviembre"},
            {id: "12", nombre: "Diciembre"},
          ],
          uploadedFiles: [],
          uploadError: null,
          currentStatus: null,
          uploadFieldName: 'photos',
          files: [],
          datosCargados: {},
          mensajeConfirmacion: ''
        }
      },
      computed: {
        isInitial() {
          return this.currentStatus === STATUS_INITIAL;
        },
        isSaving() {
          return this.currentStatus === STATUS_SAVING;
        },
        isSuccess() {
          return this.currentStatus === STATUS_SUCCESS;
        },
        isFailed() {
          return this.currentStatus === STATUS_FAILED;
        },
        isSaved() {
          return this.currentStatus === STATUS_SAVED;
        }
      },
  
      mounted() {
        var years = []
        var currentYear = new Date().getFullYear();
        var startYear = 2016;
        while (startYear <= currentYear + 1) {
          years.push({id: startYear, nombre: startYear});
          startYear++;
        }
        this.anyoOptions = years;
        this.reset();
      },
      methods: {
        reset() {
          // reset form to initial state
          this.currentStatus = STATUS_INITIAL;
          this.uploadedFiles = [];
          this.uploadError = null;
        },
        fechaIntroducida() {
          return (this.anyoValue!='' && this.monthValue!='')
        },
        async save(formData) {
          // upload data to the server
          this.currentStatus = STATUS_SAVING;
          var datos = await contabilidadService.uploadExcelContasol(formData)
          console.log(datos)
          console.log("Datos del fichero:")
          console.log(datos.data.month)
          console.log(datos.data.year)
          this.datosCargados = datos.data
          this.currentStatus = STATUS_SUCCESS;
          
  
        },
        filesChange(fieldName, fileList) {
          // handle file changes
          const formData = new FormData();
  
          if (!fileList.length) return;
  
          // append the files to FormData
          Array
            .from(Array(fileList.length).keys())
            .map(x => {
              formData.append('file', fileList[x], fileList[x].name);
            });
          formData.append('month', this.monthValue.id);
          formData.append('year', this.anyoValue.id);
  
          // save it
          this.save(formData);
        },
        async confirmarCargaDatos() {
            try {
                // Llamada al servicio
                var salida = await contabilidadService.putExcelContasol(this.datosCargados);
                // Asigna el mensaje de confirmación
                this.mensajeConfirmacion = salida.mensaje;
                this.currentStatus = STATUS_SAVED;
            } catch (error) {
                console.error("Error al confirmar los datos:", error);
            }
        }
      }
    };
  </script>
  
  <style lang="scss">
  .card-header {
    background-color: #007bff;
    color: #fff;
  }

  .dropbox {
    outline: 2px dashed grey;
    outline-offset: -10px;
    background: #f0f8ff;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px;
    position: relative;
    cursor: pointer;
    transition: background 0.3s;
  }

  .dropbox:hover {
    background: #d1ecf1;
  }

  .input-file {
    opacity: 0;
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

  .b-button {
    font-size: 1rem;
    padding: 10px 20px;
    border-radius: 8px;
    background-color: #28a745;
    color: #fff;
    transition: background-color 0.3s;
  }

  .b-button:hover {
    background-color: #218838;
  }

  .form-select {
    border-radius: 8px;
    padding: 10px;
  }

  .card {
    margin-top: 20px;
  }

  @media (max-width: 576px) {
    .dropbox p {
      font-size: 1rem;
    }

    .b-button {
      font-size: 0.875rem;
      padding: 8px 15px;
    }

    .form-select {
      font-size: 0.875rem;
      padding: 8px;
    }
  }
</style>